import classNames from "classnames";
import { useI18n } from "i18n";
import { Card } from "@remo-co/ui-core/src/components/Card";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useStyles } from "./BlankState.styles";

interface IBlankStateProps {
  presentationMode?: boolean;
}

const BlankState = ({ presentationMode }: IBlankStateProps) => {
  const { t } = useI18n(["eventDirectory"]);
  const styles = useStyles();

  return (
    <Card
      size="xs"
      flex
      fullWidth
      className={classNames(styles.blankState, {
        [styles.blankStatePresentationMode]: presentationMode,
      })}
    >
      <Typography
        variant="subtitle1"
        color="textSecondary"
        className={classNames({
          [styles.textPresentationMode]: presentationMode,
        })}
      >
        {t("eventDirectory:no.events.loaded")}
      </Typography>
    </Card>
  );
};

export default BlankState;
